export default __webpack_public_path__ + "static/media/rcs.ca8b4d89.png";